'use client';

import Image, { ImageAssetProps } from '../Image';

export default function PageImage(props: ImageAssetProps) {
  if (!props.data) return null;

  return <Image alt="page-image" {...props} />;
}
